"use client";

import React from "react";

import { useGoogleClassroomAddonStore } from "@/store";

type Props = {
  children: React.ReactNode;
  courseId: string;
  itemId: string;
  addOnToken: string;
};
export const OakGoogleClassroomProvider = ({
  children,
  courseId,
  itemId,
  addOnToken,
}: Props) => {
  const initialiseAddon = useGoogleClassroomAddonStore(
    (state) => state.initialiseAddon,
  );
  const isInitialised = useGoogleClassroomAddonStore(
    (state) => state.isInitialised,
  );
  React.useEffect(() => {
    if (!isInitialised) initialiseAddon(courseId, itemId, addOnToken);
  }, [isInitialised, initialiseAddon, courseId, itemId, addOnToken]);
  return children;
};
